import React, { useState } from 'react';
import Swal from 'sweetalert2';
import { Formik, Field, Form } from 'formik';
import * as Yup from 'yup';
import { Dialog, DialogContent, DialogTitle, Box, Typography, IconButton, Button, Grid2 as Grid, DialogActions } from '@mui/material';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { importVendors } from './service';
import PropTypes from 'prop-types';
import { objectToFormData } from '../../../utils/utils';

function ImportVendors({ open, closePopup, refresh }) {
    const [fileName, setFileName] = useState('');
    const validationSchema = Yup.object().shape({
        file: Yup.string().required('Please browse the file to import'),
    });

    const initialValues = {
        file: undefined
    };

    const handleClose = () => closePopup();

    const browseFile = (e, form, field) => {
        setFileName(e.currentTarget.files[0].name);
        form.setFieldValue(field.name, e.currentTarget.files[0]);
    };

    const handleSubmit = async (values) => {
        try {
            const formData = objectToFormData(values);
            const res = await importVendors(formData);
            if (res?.status === 'success') {
                Swal.fire(res?.message, '', 'success');
                refresh();
                handleClose();
            } else {
                Swal.fire(res?.message, '', 'error');
            }
        } catch (error) {
            const errMsg = error?.response?.data?.message || 'Some error occured!';
            Swal.fire(errMsg, '', 'error');
        }
    };

    const downloadSampleCSV = (e) => {
        e.preventDefault();
        const header = ['firstName', 'middleName', 'lastName', 'mobileNumber', 'gender', 'email', 'vendorType', 'adminType', 'doHomeCollection', 'vendorLegalName', 'serviceTypeName', 'registrationNumber', 'serviceStartTime', 'serviceEndTime', 'bankName', 'IFSCCode', 'bankAccountNo', 'UPIID', 'accountHolderName', 'serviceTypeId', 'serviceCost', 'settlementType', 'country', 'state', 'district', 'city', 'area', 'street', 'houseOrPlotNo', 'zipcode'];
        const csvContent = 'data:text/csv;charset=utf-8,' + header.join(',') + '\n';
        const encodedUri = encodeURI(csvContent);
        const link = document.createElement('a');
        link.setAttribute('href', encodedUri);
        link.setAttribute('download', 'vendors.csv');
        document.body.appendChild(link);
        link.click();
    };

    // const browseFile = () => {
    //     const fileInput = document.createElement('input');
    //     fileInput.type = 'file';
    //     // Handle file selection
    //     fileInput.addEventListener('change', (event) => {
    //         const file = event.target.files[0];
    //         // You can perform further actions with the selected file here
    //         if (file) {
    //             const fileName = file.name;
    //             const fileExtension = fileName.split('.').pop().toLowerCase();
    //             if (fileExtension !== 'csv') {
    //                 alert('Please select a CSV file.');
    //                 return;
    //             }
    //             // Proceed with further actions for a valid CSV file
    //             importFromCsv(file);
    //         }
    //     });
    //     // Trigger click event
    //     fileInput.click();
    // };

    return (
        <>

            <Dialog
                open={open}
                keepMounted
                onClose={handleClose}
                fullWidth={true}
                maxWidth='xs'
                className='viewDetails'
            >
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    {() => (
                        <Form>
                            <DialogTitle sx={{ display: 'flex', alignItems: 'center' }}>
                                <div style={{ flex: 1 }}>Import Vendors</div>
                                <IconButton onClick={() => handleClose()}><CloseOutlinedIcon /></IconButton>
                            </DialogTitle>
                            <DialogContent>
                                <Box sx={{ m: 2 }}>
                                    <Grid container spacing={2}>
                                        {/* <Grid item xs={12}>
                                            <Field
                                                id='vendorType'
                                                name='vendorType'
                                                label='Vendor Type'
                                                options={vendorTypes}
                                                component={CustomDropdown}
                                            />
                                            <ErrorMessage name='vendorType'>{msg => <div className='valErrMsg'>{msg}</div>}</ErrorMessage>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Field
                                                id='serviceTypeId'
                                                name='serviceTypeId'
                                                label='Treatu Service Type'
                                                options={serviceTypes}
                                                component={CustomDropdown}
                                            />
                                            <ErrorMessage name='serviceTypeId'>{msg => <div className='valErrMsg'>{msg}</div>}</ErrorMessage>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Field
                                                id='settlementType'
                                                name='settlementType'
                                                label='Settlement Type'
                                                options={settlementTypes}
                                                component={CustomDropdown}
                                            />
                                            <ErrorMessage name='settlementType'>{msg => <div className='valErrMsg'>{msg}</div>}</ErrorMessage>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Field
                                                id='adminType'
                                                name='adminType'
                                                label='Vendor Admin Type'
                                                options={adminTypes}
                                                component={CustomDropdown}
                                            />
                                            <ErrorMessage name='adminType'>{msg => <div className='valErrMsg'>{msg}</div>}</ErrorMessage>
                                        </Grid> */}
                                        <Grid size={{ xs: 12 }}>
                                            <Typography>
                                                Browse CSV File ( <a onClick={downloadSampleCSV}>Sample CSV</a>):
                                            </Typography>
                                            <Field name='file'>
                                                {({ field, form }) => (
                                                    <>
                                                        <Button variant='outlined' component='label'>
                                                            <input
                                                                type='file'
                                                                accept=".csv"
                                                                name={field.name}
                                                                hidden={true}
                                                                onChange={(e) => browseFile(e, form, field)}
                                                            />
                                                            Chose File
                                                        </Button>
                                                    </>
                                                )}
                                            </Field>
                                            <Typography variant='span' sx={{ ml: 2 }}>{fileName ? fileName : 'No file selected'}</Typography>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </DialogContent>
                            <DialogActions>
                                <Box sx={{ textAlign: 'right', p: 2 }}>
                                    <Button variant='outlined' color='secondary' sx={{ mr: 2 }} onClick={handleClose}>Cancel</Button>
                                    <Button type='submit' variant='contained' color='primary'>Submit</Button>
                                </Box>
                            </DialogActions>
                        </Form>
                    )}
                </Formik>
            </Dialog>

        </>
    );
}

ImportVendors.propTypes = {
    open: PropTypes.bool.isRequired,
    closePopup: PropTypes.func.isRequired,
    refresh: PropTypes.func.isRequired,
};

export default ImportVendors;
